module.exports = __webpack_public_path__ + "assets/img/c84b8ae4773de0595392d23d1d45e991.svg";